/**
 * Environmental Element Colors — default color per mappable element type
 *
 * @module core/modules/environmental/constants/element-colors
 *
 * @description
 * Colores por defecto para los tipos de elementos del módulo ambiental
 * que se representan en el mapa. El usuario puede personalizar cada color
 * desde el panel.
 */

/** Environmental element types that have map representation */
export type EnvironmentalElementId =
  | 'trees'
  | 'parks'
  | 'green-spaces'
  | 'gardens';

export const ENVIRONMENTAL_ELEMENT_COLORS: Record<EnvironmentalElementId, string> = {
  'trees':        '#10b981', // verde (árboles)
  'parks':        '#84cc16', // lima (parques)
  'green-spaces': '#22c55e', // verde claro (espacios verdes)
  'gardens':      '#14b8a6', // teal (jardines)
};

/** Set of IDs for quick lookup */
export const MAPPABLE_ELEMENT_IDS = new Set<string>(
  Object.keys(ENVIRONMENTAL_ELEMENT_COLORS),
);
